import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const benefits = ['Define qué vender (sin adivinar ni copiar)', 'Descubre tu audiencia ideal con plantillas simples', 'Arma tu oferta en 1 frase (clara y vendible)', 'Termina con un producto listo para publicar', 'Incluye checklists imprimibles + guiones de DM + prompts de contenido + nichos ganadores en 2026 + hooks virales + objeciones de venta + guiones para DM'];
  return <section className="relative w-full bg-cream-50 pt-20 pb-16 px-4 md:pt-32 md:pb-24 overflow-hidden" data-id="element-104">
      <div className="max-w-4xl mx-auto text-center" data-id="element-105">
        {/* Price Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block mb-6" data-id="element-106">
          <span className="bg-gold-500 text-white px-4 py-1.5 rounded-full text-sm font-bold tracking-wide uppercase shadow-sm" data-id="element-107">
            Edición lanzamiento: $9.99 USD
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-serif text-brown-800 leading-tight mb-6" data-id="element-108">
          De "no sé qué vender" a <br className="hidden md:block" data-id="element-109" />
          <span className="text-terracotta-500 italic" data-id="element-110">
            "ya tengo mi idea y mi plan"
          </span>{' '}
          <br className="hidden md:block" data-id="element-111" />
          en 14 días.
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-xl text-stone-600 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-112">
          Crea tu primer producto digital con propósito, aunque hoy te sientas
          confundida, con poco tiempo y sin "sentirte experta". Un plan en
          español, práctico y directo para mujeres reales (vida real).
        </motion.p>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.25,
        ease: 'easeOut'
      }} className="mb-12 mx-auto max-w-3xl" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/h871NH77MNndQCJy7pHUtu/heylloyd-image-1771263490613.png" alt="Plan 14 Días: Tu Primer Producto Digital (con Propósito) — vista previa en laptop y tablet" className="w-full h-auto rounded-2xl shadow-2xl shadow-brown-800/10" data-id="element-114" />
        </motion.div>

        {/* Bullets */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="max-w-2xl mx-auto text-left bg-white/50 p-6 md:p-8 rounded-2xl border border-cream-200 mb-10 shadow-sm" data-id="element-115">
          <ul className="space-y-4" data-id="element-116">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            delay: 0.4 + index * 0.1
          }} className="flex items-start" data-id="element-117">
                <div className="flex-shrink-0 mt-1" data-id="element-118">
                  <div className="bg-sage-500/10 rounded-full p-1" data-id="element-119">
                    <CheckIcon className="w-4 h-4 text-sage-500" strokeWidth={3} data-id="element-120" />
                  </div>
                </div>
                <span className="ml-3 text-brown-800 font-medium" data-id="element-121">
                  {benefit}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="flex flex-col items-center" data-id="element-122">
          <Button size="lg" className="w-full md:w-auto text-xl px-10 py-8" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-123">
            Comprar ahora — $9.99
          </Button>
          <p className="mt-4 text-sm text-stone-600 font-medium flex items-center gap-2" data-id="element-124">
            <span data-id="element-125">Acceso inmediato</span>
            <span className="w-1 h-1 bg-stone-600 rounded-full" data-id="element-126"></span>
            <span data-id="element-127">PDF descargable</span>
            <span className="w-1 h-1 bg-stone-600 rounded-full" data-id="element-128"></span>
            <span data-id="element-129">En español</span>
          </p>
        </motion.div>
      </div>
    </section>;
}